export default __webpack_public_path__ + "static/media/refil_savings_reminder_icon_active.de4cecaa.svg";